import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { useTheme } from 'antd-style'
import dayjs from 'dayjs'
import dompurify from 'dompurify'
import { useState } from 'react'

import { Text, Paragraph } from 'src/components'
import { dayStringMonthYearHourMinutesFormat } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  title?: string
  content?: string
  type?: string | null
  time?: string
  isRead?: boolean
  onClick: () => void
  actionUrl?: string
}

export const NotificationCard = ({
  time,
  title,
  content,
  type,
  isRead,
  onClick,
  actionUrl
}: Props) => {
  const { t } = useLocales()

  const [isExpanded, setIsExpanded] = useState(false)

  const { styles } = useStyles({ isRead })
  const palette = useTheme()
  const { currentLang } = useLocales()

  const onToggle = () => {
    setIsExpanded((prev) => !prev)
  }

  const utcDate = dayjs.utc(time)

  return (
    <Flex className={styles.card} onClick={onClick} gap={16}>
      <Flex vertical gap={8} flex={1}>
        <Flex justify="space-between" align="center">
          <Text color={palette.grey.grey1}>
            {dayjs
              .tz(utcDate)
              .locale(currentLang.value)
              .format(dayStringMonthYearHourMinutesFormat)}{' '}
            | {type}
          </Text>
        </Flex>

        <Flex vertical>
          <Text weight={600} size="xl">
            {title}
          </Text>

          <Paragraph weight={400} ellipsis={isExpanded ? false : { rows: 2 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: dompurify.sanitize(content ?? '')
              }}
            />
          </Paragraph>

          {actionUrl && (
            <Button
              size="small"
              className={styles.viewDetails}
              type="link"
              target="_blank"
              href={actionUrl}
            >
              {t('notifications.view_details')}
            </Button>
          )}
        </Flex>
      </Flex>

      <Button
        className={styles.expandIcon}
        icon={isExpanded ? <CaretUpOutlined /> : <CaretDownOutlined />}
        onClick={onToggle}
      />
    </Flex>
  )
}
